import React from "react";
import { useFormikContext, useField } from "formik";
import { useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import i18n from "i18n";
import { Input } from "components/bootstrap";
import { FormikFormGroup, Select } from "components/common";
import { AZURE_AUTH_MODE } from "./types";
const AUTH_OPTIONS = [
  { value: AZURE_AUTH_MODE.AUTOMATIC, labelKey: "azure_credentials.auth_automatic" },
  { value: AZURE_AUTH_MODE.ACCOUNT_KEY, labelKey: "azure_credentials.auth_account_key" }
];
export const validateAzureCredentialsFields = (credentials) => {
  var _a;
  const errors = {};
  if (!credentials) return errors;
  if (!credentials.auth_mode) {
    errors.auth_mode = i18n.t("azure_credentials.required", { ns: "enterprise_data_tiering" });
  }
  if (!((_a = credentials.account_name) == null ? void 0 : _a.trim())) {
    errors.account_name = i18n.t("azure_credentials.required", { ns: "enterprise_data_tiering" });
  }
  if (credentials.auth_mode === AZURE_AUTH_MODE.ACCOUNT_KEY && !credentials.account_key) {
    errors.account_key = i18n.t("azure_credentials.account_key_required", { ns: "enterprise_data_tiering" });
  }
  return errors;
};
const AzureCredentialsFieldGroup = () => {
  var _a, _b;
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const productName = useProductName();
  const { t } = useTranslation("enterprise_data_tiering");
  const authOptions = AUTH_OPTIONS.map(({ value, labelKey }) => ({ value, label: t(labelKey) }));
  const [, { error: authModeError, touched: authModeTouched }] = useField("credentials.auth_mode");
  const [, { error: accountKeyError, touched: accountKeyTouched }] = useField("credentials.account_key");
  const authMode = (_b = (_a = values.credentials) == null ? void 0 : _a.auth_mode) != null ? _b : AZURE_AUTH_MODE.AUTOMATIC;
  const handleAuthModeChange = (nextMode) => {
    if (nextMode === AZURE_AUTH_MODE.AUTOMATIC) {
      setFieldValue("credentials.account_key", void 0);
    }
    setFieldValue("credentials.auth_mode", nextMode);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "credentials.account_name",
      type: "text",
      label: t("azure_credentials.account_name"),
      placeholder: t("azure_credentials.account_name_placeholder"),
      help: t("azure_credentials.account_name_help"),
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "credentials.endpoint_uri",
      type: "text",
      label: t("azure_credentials.endpoint_uri"),
      help: t("azure_credentials.endpoint_uri_help")
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "repository-credentials-auth-mode",
      label: t("azure_credentials.auth_type"),
      bsStyle: authModeError && authModeTouched ? "error" : void 0,
      error: authModeTouched ? authModeError : void 0,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      help: t("azure_credentials.auth_mode_help", { productName })
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        inputId: "repository-credentials-auth-mode-select",
        placeholder: t("azure_credentials.auth_type_placeholder"),
        options: authOptions,
        onChange: handleAuthModeChange,
        clearable: false,
        value: authMode
      }
    )
  ), authMode === AZURE_AUTH_MODE.ACCOUNT_KEY && /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "repository-credentials-account-key",
      type: "password",
      label: t("azure_credentials.account_key"),
      error: accountKeyTouched ? accountKeyError : void 0,
      bsStyle: accountKeyError && accountKeyTouched ? "error" : void 0,
      onChange: ({ target: { value } }) => setFieldValue("credentials.account_key", value === "" ? void 0 : { set_value: value }),
      onBlur: () => setFieldTouched("credentials.account_key", true),
      placeholder: "****************",
      help: t("azure_credentials.account_key_help"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      required: true
    }
  ));
};
export default AzureCredentialsFieldGroup;
